/** Local days (yyyy-mm-dd) to the instants the log APIs take: from the start of `from` to the end of `to`. */
export function dayRange(from: string, to: string) {
  return {
    from: from ? new Date(`${from}T00:00:00`).toISOString() : undefined,
    to: to ? new Date(new Date(`${to}T00:00:00`).getTime() + 86_400_000).toISOString() : undefined,
  };
}

/** The first characters of an id, enough to tell records apart on screen. */
export const shortId = (id: string | null | undefined) => (id ? id.slice(0, 8) : '');

/** Only the values that are set, as query parameters. */
export const setOnly = (values: Record<string, string | undefined>) =>
  Object.fromEntries(Object.entries(values).filter(([, v]) => v)) as Record<string, string>;
